import { Link } from "react-router-dom";

export default function Form1() {
	return (
		<div className="widget-form-register">
			<div className="row">
				{/* Left half with background image */}
				<div className="col-md-6 pd-form image-register">
					<img src="/images/image113.jpeg" alt="Register form visual" />
				</div>

				{/* Right half with the form */}
				<div className="col-md-6 pd-form">
					<div className="widget-register background-green">
						<div className="heading-register">
							{/* Optional image/logo near the heading */}
							{/* <img src="/images/image113" alt="form banner" /> */}
							<h2 className="title-register">Join TFD Academy Now</h2>
						</div>

						{/* Contact info */}
						<div className="list-contact">
							<div className="contact">
								<span> Phone: </span>
								<div className="address">+61 457 600 287</div>
							</div>
							<div className="contact">
								<span> Email: </span>
								<div className="address">coordinator@tfdperth.com</div>
							</div>
						</div>

						{/* Social icons (optional; you can update or remove them) */}
						<ul className="social-media">
							<li>
								<Link to="https://twitter.com">
									<i className="icon-twitter" />
								</Link>
							</li>
							<li>
								<Link to="https://dribbble.com">
									<i className="icon-dribbble" />
								</Link>
							</li>
							<li>
								<Link to="https://behance.com">
									<i className="icon-behance" />
								</Link>
							</li>
							<li>
								<Link to="https://pinterest.com">
									<i className="icon-pinterest" />
								</Link>
							</li>
						</ul>

						{/* Registration form */}
						<div className="form-register">
							<form id="registerform" className="register-form" noValidate>
								<fieldset className="name-container">
									<input
										type="text"
										id="author"
										placeholder="Your name*"
										className="tb-my-input"
										name="author"
										tabIndex={1}
										size={32}
										aria-required="true"
									/>
								</fieldset>
								<fieldset className="email-container">
									<input
										type="text"
										id="email"
										placeholder="Your email*"
										className="tb-my-input"
										name="email"
										tabIndex={2}
										size={32}
										aria-required="true"
									/>
								</fieldset>
								<fieldset className="telephone-container">
									<input
										type="text"
										id="telephone"
										placeholder="Telephone*"
										className="tb-my-input"
										name="telephone"
										tabIndex={3}
										size={32}
										aria-required="true"
									/>
								</fieldset>
								<fieldset className="sex-container">
									<select
										name="sex"
										id="sexs"
										className="tb-my-input"
										aria-required="true"
									>
										<option value="">Male</option>
										<option value="female">Female</option>
									</select>
								</fieldset>
								<p className="form-submit">
									<input
										name="submit"
										type="submit"
										id="comment-reply"
										className="submit-register"
										value="Register Now"
									/>
								</p>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
